// extracted by mini-css-extract-plugin
module.exports = {"showMore":"ShowMore_showMore__LVb7u"};